import React from 'react';
import PropTypes from 'prop-types';

import UserIconNew from "../../../../gd-components/icons/user/user";
import Project from "../../../../model2/project/project";
import Task from "../../../../model2/task/task";

type Props = {
    item        : Task|Project
}

export default function TaskUsersList(props:Props) {

    const iconsToShow = 5;

    let res             = [];
    let users           = _.map(props.item.users, (tu)=>gd.session.users.get(tu.userId)!)
    const task : Task   = props.item as Task;
    const companyId     = task.companyId;
    const isOpen        = gd.const.systemStatus.isOpen(props.item.systemStatus);

    const userIcon = (id:ID, actionRequired = false, assigned = false) =>
        <div key={id} className="ico">
            <UserIconNew className="user-icon" size="22" hint="up" userId={id}/>
        </div>

    if (users.length > iconsToShow) {
        // here we need to show just 2 users, rest is rest

        // first try to add AR user
        if (task.actionRequiredUserId) res.push(userIcon(task.actionRequiredUserId, true, task.assignedToUserId === task.actionRequiredUserId));

        // then assignee if not AR
        if (task.assignedToUserId && task.assignedToUserId !== task.actionRequiredUserId) res.push(userIcon(task.assignedToUserId, false, true));

        // try add created by
        if ((res.length < iconsToShow-1) && task.actionRequiredUserId !== task.createdByUserId && task.assignedToUserId !== task.createdByUserId) {
            if (task.createdByUserId) {
                res.push(userIcon(task.createdByUserId));
            }
        }

        // i.e. user who created is ar & assigned
        let moreToShow = (iconsToShow - 1) - res.length;

        if (moreToShow > 0) {
            users.map(user=>{
                if (moreToShow > 0 &&
                    user.id !== task.createdByUserId &&
                    user.id !== task.actionRequiredUserId &&
                    user.id !== task.assignedToUserId) {
                    res.push(userIcon(user.id));
                    moreToShow--;
                }
            });
        }

        const more = users.length - res.length;
        if (more > 0)
            res.push(
                <div key="more" className="ico">
                    <div className="ui5-counter circle-user">+{more}</div>
                </div>
            )

    } else {
        if (task.actionRequiredUserId && isOpen) res.push(userIcon(task.actionRequiredUserId, true));
        if (task.assignedToUserId && task.assignedToUserId !== task.actionRequiredUserId) res.push(userIcon(task.assignedToUserId, false, true));

        users.map(user=>{
            if (user.id !== task.assignedToUserId && user.id !== task.actionRequiredUserId) res.push(userIcon(user.id));
        });
    }

    return <div className="ui5-users-group">{res}</div>;
}

// TaskUsersList.propTypes = {
//     item: PropTypes.object
// };